import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const InterestIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
        >
            <path
                d="M1.6875 12H2.83333M12 1.6875V2.83333M21.1667 12H22.3125M4.66667 4.66667L5.46875 5.46875M19.3333 4.66667L18.5313 5.46875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.56251 16.5833C7.60055 15.8619 6.88998 14.856 6.53144 13.7082C6.17291 12.5605 6.1846 11.329 6.56485 10.1883C6.94509 9.04753 7.67463 8.05534 8.65011 7.35225C9.62559 6.64917 10.7976 6.27083 12 6.27083C13.2025 6.27083 14.3744 6.64917 15.3499 7.35225C16.3254 8.05534 17.0549 9.04753 17.4352 10.1883C17.8154 11.329 17.8271 12.5605 17.4686 13.7082C17.11 14.856 16.3995 15.8619 15.4375 16.5833C14.9901 17.0262 14.6533 17.5681 14.4542 18.1653C14.2552 18.7625 14.1995 19.3981 14.2917 20.0208C14.2917 20.6286 14.0502 21.2115 13.6205 21.6413C13.1907 22.0711 12.6078 22.3125 12 22.3125C11.3922 22.3125 10.8093 22.0711 10.3796 21.6413C9.94979 21.2115 9.70834 20.6286 9.70834 20.0208C9.80053 19.3981 9.74484 18.7625 9.54578 18.1653C9.34672 17.5681 9.00988 17.0262 8.56251 16.5833Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9.36459 17.7292H14.6354" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconWrapper>
)
